module.exports = __webpack_public_path__ + "static/program-components-be6bf754ee4d47a7481940e97ac5aded.jpg";